module.exports = __webpack_public_path__ + "media/audio118.6a4638d9.mp3";